export default __webpack_public_path__ + "static/hb20-8f11b4a938626072b3e385d36a6403b8.png";